import React from "react";
import Icon from "./Icon";

const Option = ({ name, description, iconName, onClick, onKeyPress, optionClassName }) => {
  return (
    <div className="c-quiz_options--option">
      <div
        className={`uk-card uk-card-default uk-card-body c-quiz_options--option-body ${
          optionClassName ? optionClassName : ""
        }`}
        onClick={onClick}
        onKeyPress={onKeyPress}
      >
        {iconName && (
          <Icon iconName={iconName} className={"c-quiz_icon icon-sm"} />
        )}
        <h3>{name}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default Option;
